import cx from 'classnames'
import { useIntl } from 'react-intl'

import Money from '../Money/Money'
import PointPayment from './components/PointPayment/PointPayment'
import TicketPart from './components/TicketPart/TicketPart'
import TicketSeat from './components/TicketSeat/TicketSeat'
import hocTicketPayment from './hocTicketPayment'

import InfoLine from '../../pages/OrderSummary/components/InfoLine/InfoLine'
import './Ticket.scss'

const TicketPayment = ({
    ticket,
    showLine = false,
    className,
    disabledPointPayment,
    payTicketWithMoney,
    payTicketWithPoints,
    isClubMember,
    isReservation,
}) => {
    const intl = useIntl()
    const seatProp = { label: `${ticket.row} ${ticket.seat}` }
    const voucherAppliedText = intl.formatMessage({ id: 'orderSummary.ticketsDescription.voucherApplied' })
    const ticketType = ticket.voucher ? voucherAppliedText : ticket.customer_category?.name

    const onPointPaymentSelect = () => {
        if (ticket.used_points) {
            payTicketWithMoney(ticket.ticketid)
            return
        }
        payTicketWithPoints(ticket.ticketid)
    }

    return (
        <>
            {showLine && (
                <InfoLine text={intl.formatMessage({ id: 'orderSummary.ticketsDescription.maxTicketsLine' })} />
            )}
            <div className={cx('ticket ticket__payment', className)}>
                <TicketSeat seat={seatProp} />
                <TicketPart className={'border-radius-left separator-right text-basePrimary'}>
                    <span>{ticketType ?? intl.formatMessage({ id: 'ticket.type.basic' })}</span>
                </TicketPart>
                <TicketPart className={(!isClubMember || isReservation) && 'border-radius-right'}>
                    <div className={`price-container text-magentaSecondary`}>
                        <Money amount={!ticket.used_points ? ticket?.price : 0} currency={ticket?.currency} />
                    </div>
                </TicketPart>
                {isClubMember && !isReservation && (
                    <TicketPart className={'border-radius-right'}>
                        <PointPayment
                            onChange={onPointPaymentSelect}
                            checked={ticket.used_points}
                            points={ticket.price}
                            disabled={disabledPointPayment}
                        />
                    </TicketPart>
                )}
            </div>
        </>
    )
}

export default hocTicketPayment(TicketPayment)
